import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TransferState, makeStateKey } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';
import { getWeightedRandom } from 'src/app/core/common';
import { JobCriteria, SearchParams } from 'src/app/common';
import { JobService } from 'src/app/services/job.service';
import { SharedService } from 'src/app/services/shared.service';

declare let $: any;
type suggestState = {
  advertise?: any;
};

@Component({
  selector: 'app-suggester',
  templateUrl: './suggester.component.html',
  styleUrls: ['./suggester.component.scss']
})
export class SuggesterComponent {
  initialized: boolean;
  constructor(private sharedService: SharedService, private jobService: JobService, private transferState: TransferState) {
    this.isSsr = !this.sharedService.isBrowser;
  }

  private readonly prerenderStateKey = makeStateKey<suggestState>('app-suggestion-prerender');
  state$ = new BehaviorSubject<suggestState>(null);
  isSsr: boolean;

  @Output('question-key') onQuestion = new EventEmitter<string>();
  private _appliedParams: SearchParams;
  public get appliedParams(): SearchParams {
    return this._appliedParams;
  }
  @Input()
  public set appliedParams(value: SearchParams) {
    this._appliedParams = value;
    if(this.initialized) this.load();
  }

  external?: boolean = false;
  async ngOnInit() {
    if (this.sharedService.isBrowser) {
      let state = this.transferState.get(this.prerenderStateKey, null);
      if (state) {
        this.transferState.remove(this.prerenderStateKey);
        this.state$.next(state);
      } else {
        await this.load();
      }
    } else {
      await this.loadForSsr();
    }
    this.initialized = true;
  }

  async load() {
    let state = {};
    await this.loadAdvertise(state);
    this.state$.next(state);
  }


  async loadForSsr() {
    let state = {};
    await this.loadAdvertise(state);
    this.state$.next(state);
    this.transferState.set(this.prerenderStateKey, this.state$.value);
  }

  private async loadAdvertise(state: suggestState) {
    let advertises = await this.jobService.getSuggestedAdvertises(JobCriteria.fromParams(this.appliedParams));
    state.advertise = (advertises?.length > 0) ? getWeightedRandom(advertises, 'Weight', 50) : null;
    this.external = state.advertise?.Link?.startsWith('http');
    // TODO:
    // this.analyticsService.gtmEvent('advertise-view', 'seeker', this.extraCards.advertises[0].Title || this.extraCards.advertises[0].Id);
  }
}
